// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu-module--submenu--3Y2cn","submenuRight":"Submenu-module--submenuRight--385YH"};